import { TypedUseSelectorHook, useSelector } from 'react-redux'
import type { RootState } from './store'

//TODO: Сделать диспатчер для приложения
// type DispatchFunc = () => AppDispatch
// export const useAppDispatch: DispatchFunc = useDispatch

export const useAsonikaSelector: TypedUseSelectorHook<RootState> = useSelector